module.exports = __webpack_public_path__ + "media/fonts/RecklessNeue-SemiBold-ed350d9a851d6e0a974a5b2606080792.ttf";